// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"50":"889144be3bc4371f","674":"e758bb620d95c3ab"}[chunkId] + ".css";
};